import { render, staticRenderFns } from "./InfoSoc.vue?vue&type=template&id=0da15982"
import script from "./InfoSoc.vue?vue&type=script&lang=js"
export * from "./InfoSoc.vue?vue&type=script&lang=js"
import style0 from "./InfoSoc.vue?vue&type=style&index=0&id=0da15982&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports